import { useViewBoard } from "./use-view-board";

// Undefined until the board resolves, so a caller can tell "no board yet" apart from
// "empty board" instead of treating both as zero.
export function useBoardElementCount(): number | undefined {
  const { board } = useViewBoard();

  if (board === undefined) return undefined;

  return board.tokens.length + board.drawings.length + board.texts.length;
}

// The point at which a board stops being a doodle and starts being work the user would
// mind losing. Shared so the share-formation and sign-in prompts agree on what counts
// as an engaged user rather than drifting apart.
export const minEngagedBoardElements = 5;
